/**
 * @see https://github.com/w8r/Leaflet.Path.Transform 
 * 原插件不支持点的旋转，特此修改
 */
import VectorMarker from '@/feature/VectorMarker';
//
let {
  _createRotationHandlers,
  _onRotate,
  _onRotateEnd
} = L.Handler.PathTransform.prototype;
/**
 * 
 */
L.Handler.PathTransform.include({
  /**
   * 旋转句柄
   */
  _createRotationHandlers() {
    let {
      _map,
      _rect
    } = this;

    if (_rect instanceof VectorMarker) {

      let {
        _latlng
      } = _rect;
      //
      let lineOffset = [0, -16]
      let topPoint = _map.unproject(_map.project(_latlng).add(lineOffset));
      //
      let offset = [0, -30];
      let handlerPosition = _map.unproject(_map.project(_latlng).add(offset));
      //
      let {
        options,
        _handlersGroup
      } = this;
      //
      this._handleLine = L.polyline([topPoint, handlerPosition], options.rotateHandleOptions).addTo(_handlersGroup);
      //
      let _rotationMarker = this._rotationMarker = new L.PathTransform.RotateHandle(handlerPosition, options.handlerOptions)
        .addTo(_handlersGroup)
        .on('mousedown', this._onRotateStart, this);
      //
      this._rotationOrigin = _latlng.clone();
      this._handlers.push(_rotationMarker);
    } else {
      _createRotationHandlers.call(this)
    }

    _rect.bringToBack(); //放置遮盖在图元上的

  },
  /**
   * @param  {Event} evt
   */
  _onRotate(evt) {
    _onRotate.call(this, evt);
    // 马上响应结果
    // 让旋转句柄跟着旋转
    if (this._rect instanceof VectorMarker) {
      this._rect.options.angle = this._angle;
      this._rect.redraw();
    } else { // 线面
      this._path.editLayer.clearLayers();
      this._transformGeometries();
    }
  },
  /**
   * 
   * @param {*} evt 
   */
  _onRotateEnd(evt) {
    _onRotateEnd.call(this, evt);
    this._temp = null;
  },
  /**
   * Applies transformation, does it in one sweep for performance,
   * so don't be surprised about the code repetition.
   *
   * @param {L.Path}    path
   * @param {Number=}   angle
   * @param {L.Point=}  scale
   * @param {L.LatLng=} rotationOrigin
   * @param {L.LatLng=} scaleOrigin
   */
  _transformPoints(path, angle, scale, rotationOrigin, scaleOrigin) {
    var map = path._map;
    var zoom = map.getMaxZoom() || this.options.maxZoom;
    var i, len;

    var projectedMatrix = this._projectedMatrix = this._getProjectedMatrix(angle, scale, rotationOrigin, scaleOrigin);

    // all shifts are in-place
    if (path._point) { // L.Circle
      path._latlng = this._transformPoint(path._latlng, projectedMatrix, map, zoom);
    } else if (path._rings || path._parts) { // everything else
      var rings = path._rings;
      var latlngs = path._latlngs;
      path._bounds = L.latLngBounds();
      //
      if (!T.isArray(latlngs[0])) { // polyline
        latlngs = [latlngs];
      }
      let flag = !!this._temp;
      let temp = this._temp = this._temp || [];

      for (i = 0, len = rings.length; i < len; i++) {
        for (var j = 0, jj = rings[i].length; j < jj; j++) {
          // latlngs
          if (!flag) {
            temp[i] = temp[i] || [];
            temp[i][j] = latlngs[i][j].clone();
          }
          latlngs[i][j] = this._transformPoint(temp[i][j], projectedMatrix, map, zoom);
          path._bounds.extend(latlngs[i][j]);
        }
      }
    }

    path._reset();

  },

  /**
   * Bounding polygon
   * @return {L.Polygon}
   */
  _getBoundingPolygon() {
    let {
      _path
    } = this;
    //
    if (this._rectShape && this._rectShape.geometry.type !== 'Point') {
      return L.GeoJSON.geometryToLayer(
        this._rectShape, this.options.boundsOptions);
    } else if (_path.getBounds) {
      return new L.Rectangle(_path.getBounds(), this.options.boundsOptions);
    } else { //添加点的旋转
      let {
        _latlng,
        options
      } = _path;
      _latlng = _latlng.clone();
      //
      let feature = new VectorMarker(_latlng, {
        src: 'rect',
        radius: 32,
        radiusY: 32,
        weight: 2,
        color: 'red',
        fill: false,
        noClip: true,
        angle: options.angle,
        dashArray: [5, 5]
      });
      //
      feature._latlngs = [
        [_latlng, _latlng, _latlng, _latlng]
      ]
      //
      return feature;
    }
  }
})



// WEBPACK FOOTER //
// ./src/handle/Transform.js